/* Joey's Houseplants theme JS — Designed & built by KAHANI | Dev: Prashanth Rathod */
(function(){
  var FREE = 150;

  /* arrives-by on PDP — nationwide shipping estimate */
  var al = document.getElementById('arrive-line'), asub = document.getElementById('arrive-sub');
  if(al){
    var now = new Date();
    function f(d){ return d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'}); }
    var a = new Date(now); a.setDate(a.getDate()+2);
    var b = new Date(now); b.setDate(b.getDate()+4);
    al.textContent = 'Arrives ' + f(a) + ' – ' + f(b);
    if(asub) asub.textContent = 'shipped bare-root with our arrive-safe promise';
  }

  /* scroll reveals — pre-trigger 240px before entering viewport */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); },{threshold:0, rootMargin:'0px 0px 240px 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else { document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); }); }

  /* mobile menu */
  var mt = document.querySelector('[data-menu-toggle]');
  if(mt) mt.addEventListener('click', function(){
    var m = document.getElementById('mobile-menu');
    var open = m.classList.toggle('open');
    mt.setAttribute('aria-expanded', open);
  });

  /* footer year */
  document.querySelectorAll('.jyr').forEach(function(el){ el.textContent = new Date().getFullYear(); });

  /* PDP: thumbs, variant pills, qty */
  document.querySelectorAll('[data-thumb]').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('[data-thumb]').forEach(function(b){ b.classList.remove('sel'); });
      btn.classList.add('sel');
      document.getElementById('main-img').src = btn.dataset.thumb;
    });
  });
  document.querySelectorAll('.size-opt').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(btn.dataset.soldout) return;
      document.querySelectorAll('.size-opt').forEach(function(b){ b.classList.remove('sel'); });
      btn.classList.add('sel');
      var v = document.getElementById('pdp-variant'); if(v) v.value = btn.dataset.variant;
      var p = document.getElementById('pdp-price'); if(p) p.textContent = btn.dataset.price;
    });
  });
  var qty = 1;
  document.querySelectorAll('[data-qty]').forEach(function(btn){
    btn.addEventListener('click', function(){
      qty = Math.min(9, Math.max(1, qty + parseInt(btn.dataset.qty,10)));
      var o = document.getElementById('qty-out'); if(o) o.textContent = qty;
      var i = document.getElementById('pdp-qty'); if(i) i.value = qty;
    });
  });
  var giftCb = document.getElementById('gift-cb');
  if(giftCb) giftCb.addEventListener('change', function(){
    document.getElementById('gift-note-field').style.display = this.checked ? 'block' : 'none';
  });

  /* ---------- CART DRAWER (Shopify AJAX) ---------- */
  var overlay = document.getElementById('jc-overlay');
  var drawer = document.getElementById('jc-drawer');
  function money(cents){ return '$' + (cents/100).toFixed(2).replace(/\.00$/,''); }
  function escapeCartHtml(value){ return String(value || '').replace(/[&<>"']/g, function(char){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]; }); }
  function openDrawer(){ refresh().then(function(){ overlay.classList.add('open'); drawer.classList.add('open'); }); }
  function closeDrawer(){ overlay.classList.remove('open'); drawer.classList.remove('open'); }
  if(overlay) overlay.addEventListener('click', closeDrawer);
  var jcClose = document.getElementById('jc-close');
  if(jcClose) jcClose.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });
  document.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click', openDrawer); });

  /* Swipe right to close the cart; keep vertical scrolling and form controls native. */
  if(drawer){
    var cartSwipe = null;
    var cartSwipeClickUntil = 0;
    drawer.addEventListener('touchstart', function(e){
      cartSwipe = null;
      cartSwipeClickUntil = 0;
      if(!drawer.classList.contains('open') || e.touches.length !== 1) return;
      if(e.target.closest && e.target.closest('input,select,textarea,[contenteditable="true"]')) return;
      var touch = e.touches[0];
      cartSwipe = {id:touch.identifier,x:touch.clientX,y:touch.clientY,started:Date.now(),horizontal:false};
    }, {passive:true});
    drawer.addEventListener('touchmove', function(e){
      if(!cartSwipe) return;
      if(e.touches.length !== 1 || !drawer.classList.contains('open')){ cartSwipe = null; return; }
      var touch = e.touches[0];
      if(touch.identifier !== cartSwipe.id){ cartSwipe = null; return; }
      var dx = touch.clientX - cartSwipe.x;
      var dy = touch.clientY - cartSwipe.y;
      if(!cartSwipe.horizontal){
        if(Math.max(Math.abs(dx),Math.abs(dy)) < 12) return;
        if(dx <= 0 || dx < Math.abs(dy) * 1.5){ cartSwipe = null; return; }
        cartSwipe.horizontal = true;
      }
      if(e.cancelable) e.preventDefault();
    }, {passive:false});
    drawer.addEventListener('touchend', function(e){
      var swipe = cartSwipe;
      cartSwipe = null;
      if(!swipe || e.touches.length) return;
      var touch = Array.prototype.find.call(e.changedTouches, function(t){ return t.identifier === swipe.id; });
      if(!touch) return;
      var dx = touch.clientX - swipe.x;
      var dy = touch.clientY - swipe.y;
      if(dx >= 64 && dx > Math.abs(dy) * 1.5 && Date.now() - swipe.started < 1200 && drawer.classList.contains('open')){
        cartSwipeClickUntil = Date.now() + 500;
        if(e.cancelable) e.preventDefault();
        closeDrawer();
      }
    }, {passive:false});
    drawer.addEventListener('touchcancel', function(){ cartSwipe = null; }, {passive:true});
    drawer.addEventListener('click', function(e){
      if(Date.now() < cartSwipeClickUntil){ e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
  }

  /* Offer a pot and stand bundle after a 10-inch plant is added. */
  var POT_IDS = [8600295571490, 8600293212194];
  var POT_HANDLES = ['smooth-10-pot', 'fluted-11-pot'];
  var STAND_ID = 8599942365218;
  var STAND_HANDLE = 'bamboo-plant-stand';
  var BUNDLE_CODE = 'CARTLOOK75SPLIT';
  function bundlePrice(potCents, standCents){ return potCents + standCents - 2998; }
  var upsellRequest = 0;
  var potUpsellDismissed = false;
  var meterUpsellDismissed = false;
  var METER_ID = 8594509103138;
  var recentPlantKey = null;
  function isEligiblePlant(item){ return item.product_type === 'Plant' && /^10[\"″]/.test(item.product_title); }
  function rememberAddedPlant(added){
    var addedItems = added && (added.items || [added]);
    var plant = addedItems && addedItems.find(isEligiblePlant);
    if(plant) recentPlantKey = plant.key;
  }
  if(!document.getElementById('jc-bundle-offer-styles')){
    var bundleStyles = document.createElement('style');
    bundleStyles.id = 'jc-bundle-offer-styles';
    bundleStyles.textContent = '#jc-upsell.jc-bundle-offer{background:#f3f7e9;border:2px solid #315b36;border-radius:14px;padding:16px;margin:14px 0;box-shadow:0 7px 20px rgba(30,68,35,.12)}' +
      '#jc-upsell .jc-bundle-badge{display:inline-block;background:#315b36;color:#fff;font-size:13px;font-weight:800;letter-spacing:.05em;padding:7px 11px;border-radius:999px;margin-bottom:10px}' +
      '#jc-upsell .jc-bundle-title{font-size:18px;font-weight:800;line-height:1.25;color:#203d25;margin-bottom:5px}' +
      '#jc-upsell .jc-bundle-subtitle{font-size:13px;line-height:1.4;color:#354737;margin-bottom:10px}' +
      '#jc-upsell .jc-bundle-price{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap;margin:14px 0 10px;color:#1d3621}' +
      '#jc-upsell .jc-bundle-price s{font-size:14px;color:#68766a}' +
      '#jc-upsell .jc-bundle-price strong{font-size:27px;line-height:1;font-weight:900;color:#21542d}' +
      '#jc-upsell .jc-bundle-save{display:inline-block;background:#d9edcb;color:#20512b;border-radius:5px;padding:3px 7px;font-size:12px;font-weight:800}' +
      '#jc-upsell .jc-up-add{display:block;width:100%;min-height:46px;background:#2c6337!important;color:#fff!important;border:0;border-radius:8px;font-size:14px;font-weight:800;cursor:pointer;opacity:1!important}' +
      '#jc-upsell .jc-up-add:hover{background:#204e2b}' +
      '#jc-upsell .jc-up-add:disabled{opacity:.65;cursor:wait}' +
      '#jc-upsell.jc-meter-offer{background:#fafbf7;border:1px solid #dbe3d7;border-radius:10px;padding:12px;margin:12px 0}' +
      '#jc-upsell .jc-meter-row{display:flex;gap:11px;align-items:center}' +
      '#jc-upsell .jc-meter-row img{width:54px;height:54px;object-fit:cover;border-radius:7px}' +
      '#jc-upsell .jc-meter-title{font-size:14px;font-weight:800;color:#203d25}' +
      '#jc-upsell .jc-meter-copy{font-size:12px;line-height:1.35;color:#536453;margin-top:3px}' +
      '#jc-upsell .jc-meter-actions{display:flex;align-items:center;gap:12px;margin-top:10px}' +
      '#jc-upsell .jc-meter-add{background:#315b36;color:#fff;border:0;border-radius:7px;padding:8px 12px;font-size:12px;font-weight:700;cursor:pointer}' +
      '#jc-upsell .jc-meter-decline{background:transparent;border:0;color:#667567;font-size:12px;text-decoration:underline;cursor:pointer}' +
      '#jc-items .jc-item .p s{display:block;color:#7b817b;font-size:12px;font-weight:400;line-height:1.3}';
    document.head.appendChild(bundleStyles);
  }
  function meterOffer(box, cart, request){
    box.classList.remove('jc-bundle-offer');
    if(meterUpsellDismissed || cart.items.some(function(item){ return item.product_id === METER_ID; })){
      box.classList.remove('jc-meter-offer'); box.innerHTML = ''; return;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/moisture-meter.js').then(function(response){
      if(!response.ok) throw new Error('Meter unavailable');
      return response.json();
    }).then(function(product){
      if(request !== upsellRequest) return;
      var variant = product.variants && product.variants.find(function(item){ return item.available && !item.requires_selling_plan; });
      if(!variant){ box.classList.remove('jc-meter-offer'); box.innerHTML = ''; return; }
      box.classList.add('jc-meter-offer');
      box.innerHTML = '<div class="jc-meter-row"><a href="' + root + 'products/moisture-meter"><img src="' + escapeCartHtml(product.featured_image || '') + '" alt="Moisture Meter"></a>' +
        '<div><div class="jc-meter-title">Keep Watering Simple</div><div class="jc-meter-copy">A moisture meter shows when the soil is dry, helping you avoid overwatering. Add one for <strong>' + money(variant.price) + '</strong>.</div></div></div>' +
        '<div class="jc-meter-actions"><button class="jc-meter-add" type="button">Add Moisture Meter</button><button class="jc-meter-decline" type="button">No thanks</button></div>';
      box.querySelector('.jc-meter-decline').addEventListener('click', function(){ meterUpsellDismissed = true; box.classList.remove('jc-meter-offer'); box.innerHTML = ''; });
      box.querySelector('.jc-meter-add').addEventListener('click', function(){
        var button = this;
        button.disabled = true;
        button.textContent = 'Adding…';
        fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:variant.id,quantity:1}]})})
          .then(function(response){ if(!response.ok) throw new Error('Could not add meter'); return response.json(); })
          .then(function(){ meterUpsellDismissed = true; return refresh(); })
          .catch(function(){ button.disabled = false; button.textContent = 'Please try again'; });
      });
    }).catch(function(){ if(request === upsellRequest){ box.classList.remove('jc-meter-offer'); box.innerHTML = ''; } });
  }
  function upsell(cart){
    var box = document.getElementById('jc-upsell');
    if(!box) return;
    var cartItems = document.getElementById('jc-items');
    var plantIndex = cart.items.findIndex(function(item){ return isEligiblePlant(item) && item.key === recentPlantKey; });
    if(plantIndex < 0) plantIndex = cart.items.findIndex(isEligiblePlant);
    var plantRow = cartItems && cartItems.children[plantIndex];
    if(plantRow) plantRow.after(box);
    else if(cartItems && box.previousElementSibling !== cartItems) cartItems.after(box);
    var request = ++upsellRequest;
    if(!cart.items.length){ box.classList.remove('jc-bundle-offer', 'jc-meter-offer'); box.innerHTML = ''; return; }
    var hasPlant = plantIndex >= 0;
    var hasPot = cart.items.some(function(item){ return POT_IDS.indexOf(item.product_id) !== -1; });
    var hasStand = cart.items.some(function(item){ return item.product_id === STAND_ID; });
    if(!hasPlant){ box.classList.remove('jc-bundle-offer', 'jc-meter-offer'); box.innerHTML = ''; return; }
    if(potUpsellDismissed || (hasPot && hasStand)){ meterOffer(box, cart, request); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function getProduct(handle){
      return fetch(root + 'products/' + handle + '.js').then(function(response){
        if(!response.ok) throw new Error('Product unavailable');
        return response.json();
      });
    }
    function firstAvailable(product){
      return product.variants && product.variants.find(function(variant){ return variant.available && !variant.requires_selling_plan; });
    }
    function addBundle(variants, button){
      button.disabled = true;
      button.textContent = 'Adding…';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: variants.map(function(variant){ return {id: variant.id, quantity: 1}; })})
      })
        .then(function(response){ if(!response.ok) throw new Error('Could not add items'); return response.json(); })
        .then(function(){
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({discount: (cart.discount_codes || []).map(function(item){ return item.code; }).filter(function(code){ return code && ['POTSTAND40', 'CARTLOOK75', BUNDLE_CODE].indexOf(code.toUpperCase()) === -1; }).concat([BUNDLE_CODE]).join(',')})
          }).then(function(response){ if(!response.ok) throw new Error('Could not apply discount'); return response.json(); });
        })
        .then(function(){ potUpsellDismissed = true; return refresh(); })
        .catch(function(){ button.disabled = false; button.textContent = 'Please try again'; refresh(); });
    }
    Promise.all(POT_HANDLES.map(getProduct).concat([getProduct(STAND_HANDLE)])).then(function(allProducts){
      if(request !== upsellRequest) return;
      var stand = allProducts.pop();
      var standVariant = firstAvailable(stand);
      var products = allProducts.filter(function(product){ return product.available && firstAvailable(product); });
      if((!hasPot && !products.length) || (!hasStand && !standVariant)){ box.classList.remove('jc-bundle-offer'); box.innerHTML = ''; return; }
      var existingPot = cart.items.find(function(item){ return POT_IDS.indexOf(item.product_id) !== -1; });
      var existingStand = cart.items.find(function(item){ return item.product_id === STAND_ID; });
      var potPrice = existingPot ? existingPot.original_price : (firstAvailable(products[0]) || {}).price;
      var standPrice = existingStand ? existingStand.original_price : standVariant.price;
      var regular = potPrice + standPrice;
      var bundle = bundlePrice(potPrice, standPrice);
      box.classList.add('jc-bundle-offer');
      box.innerHTML = '<div class="jc-bundle-badge">Cart Only Special · 29% Off</div>' +
        '<div class="jc-bundle-title">Get the Complete Look</div>' +
        '<div class="jc-bundle-subtitle">' + (hasPot ? 'Add the stand to complete the look. Your cart savings apply automatically.' : hasStand ? 'Choose your pot style and color. We’ll add the pot to your cart.' : 'Choose your pot style and color. We’ll add the stand with your pot.') + '</div>' +
        '<div class="jc-item"><a class="jc-pot-thumb jc-up-link" href=""><img alt=""></a><div><a class="n jc-up-link" style="display:block;color:inherit;text-decoration:none" href=""></a><div class="v"></div></div></div>' +
        (!hasPot ? '<div class="jc-up-options" style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin:12px 0 2px">' +
        '<label style="display:block;min-width:0;font-size:12px;font-weight:700;color:#345b3a">Pot style <select class="jc-up-style" style="display:block;width:100%;margin-top:5px;padding:9px 8px;border:1px solid #aab9a8;border-radius:8px;background:#fff;color:#1d2d1c"></select></label>' +
        '<label style="display:block;min-width:0;font-size:12px;font-weight:700;color:#345b3a">Color <select class="jc-up-color" style="display:block;width:100%;margin-top:5px;padding:9px 8px;border:1px solid #aab9a8;border-radius:8px;background:#fff;color:#1d2d1c"></select></label></div>' : '') +
        '<div class="jc-bundle-price"> <s>' + money(regular) + '</s> <strong>' + money(bundle) + '</strong> <span class="jc-bundle-save">SAVE ' + money(regular - bundle) + '</span></div>' +
        '<button class="jc-up-add" type="button" style="color:#fff!important;-webkit-text-fill-color:#fff!important"><span style="color:#fff!important;-webkit-text-fill-color:#fff!important">' + (hasPot ? 'Add stand · complete the look' : hasStand ? 'Add pot · complete the look' : 'Add pot + stand · ' + money(bundle)) + '</span></button>' +
        '<button class="jc-up-decline" type="button" style="display:block;margin:10px auto 0;padding:8px;border:0;background:transparent;color:#345b3a;text-decoration:underline;cursor:pointer">No thanks</button>';
      box.querySelector('.jc-up-decline').addEventListener('click', function(){ potUpsellDismissed = true; meterOffer(box, cart, request); });
      var button = box.querySelector('.jc-up-add');
      var style = box.querySelector('.jc-up-style');
      var color = box.querySelector('.jc-up-color');
      if(!hasPot){
        products.forEach(function(product, index){
          var option = document.createElement('option');
          option.value = String(index);
          option.textContent = product.title;
          style.appendChild(option);
        });
      }
      function availableVariants(){
        return hasPot ? [] : products[Number(style.value)].variants.filter(function(variant){
          return variant.available && !variant.requires_selling_plan;
        });
      }
      function updatePot(){
        var product = hasPot ? null : products[Number(style.value)];
        var variant = hasPot ? null : availableVariants().find(function(item){ return String(item.id) === color.value; }) || availableVariants()[0];
        var image = box.querySelector('img');
        image.src = hasPot ? (existingPot.image || '') : (variant.featured_image && variant.featured_image.src) || product.featured_image || '';
        image.alt = hasPot ? existingPot.product_title : product.title + ' - ' + (variant.option1 || variant.title);
        box.querySelector('.n').textContent = hasPot ? existingPot.product_title : product.title;
        box.querySelector('.v').textContent = hasPot ? 'Your selected pot + Bamboo Plant Stand' : (variant.option1 || variant.title) + ' + Bamboo Plant Stand';
        if(hasPot) box.querySelectorAll('.jc-up-link').forEach(function(link){ link.href = existingPot.url; });
        if(!hasPot){
          var url = root + 'products/' + encodeURIComponent(product.handle) + '?variant=' + variant.id;
          box.querySelectorAll('.jc-up-link').forEach(function(link){ link.href = url; });
          potPrice = variant.price;
          regular = potPrice + standPrice;
          bundle = bundlePrice(potPrice, standPrice);
        }
        box.querySelector('.jc-bundle-price').innerHTML = '<s>' + money(regular) + '</s> <strong>' + money(bundle) + '</strong> <span class="jc-bundle-save">SAVE ' + money(regular - bundle) + '</span>';
        if(!hasPot && !hasStand) button.querySelector('span').textContent = 'Add pot + stand · ' + money(bundle);
      }
      function updateColors(){
        color.innerHTML = '';
        availableVariants().forEach(function(variant){
          var option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.option1 || variant.title;
          color.appendChild(option);
        });
        updatePot();
      }
      if(style){ style.addEventListener('change', updateColors); color.addEventListener('change', updatePot); updateColors(); }
      else updatePot();
      button.addEventListener('click', function(){
        var selectedPot = hasPot ? null : availableVariants().find(function(item){ return String(item.id) === color.value; });
        var variants = [];
        if(selectedPot) variants.push(selectedPot);
        if(!hasStand) variants.push(standVariant);
        if(variants.length) addBundle(variants, button);
      });
    }).catch(function(){ if(request === upsellRequest){ box.classList.remove('jc-bundle-offer'); box.innerHTML = ''; } });
  }

  function render(cart){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = cart.item_count; });
    var ship = document.getElementById('jc-ship'), items = document.getElementById('jc-items');
    if(!ship) return;
    var offer = document.getElementById('jc-upsell');
    if(offer && items.contains(offer)) items.after(offer);
    var sub = cart.total_price;
    var freeCents = FREE * 100;
    if(sub >= freeCents){ ship.innerHTML = 'You’ve unlocked free nationwide shipping!<div id="jc-bar"><i style="width:100%"></i></div>'; }
    else { ship.innerHTML = money(freeCents - sub) + ' away from free nationwide shipping<div id="jc-bar"><i style="width:' + Math.round(sub/freeCents*100) + '%"></i></div>'; }
    if(!cart.items.length){
      items.innerHTML = '<div id="jc-empty">Your cart is empty.<br>Your future jungle disagrees.</div>';
    } else {
      items.innerHTML = cart.items.map(function(i, idx){
        return '<div class="jc-item"><a href="' + escapeCartHtml(i.url) + '" aria-label="View ' + escapeCartHtml(i.product_title) + '"><img src="' + escapeCartHtml(i.image || '') + '&width=120" alt=""></a><div><a class="n" style="display:block;color:inherit;text-decoration:none" href="' + escapeCartHtml(i.url) + '">' + escapeCartHtml(i.product_title) + '</a>' +
          (i.variant_title && i.variant_title !== 'Default Title' ? '<div class="v">' + i.variant_title + '</div>' : '') +
          '<div class="jc-qty"><button data-line="' + (idx+1) + '" data-d="-1">−</button><span>' + i.quantity + '</span><button data-line="' + (idx+1) + '" data-d="1">+</button></div>' +
        (i.product_type === 'Plant' ? '<div class="jc-item-guarantee"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-4.5"/></svg><span>Healthy Arrival Guaranteed</span></div>' : '') + '</div>' +
          '<div class="p">' + money(i.final_line_price) + ((POT_IDS.indexOf(i.product_id) !== -1 || i.product_id === STAND_ID) && i.original_line_price > i.final_line_price ? '<s aria-label="Regular price">' + money(i.original_line_price) + '</s>' : '') + '</div></div>';
      }).join('');
      items.querySelectorAll('[data-line]').forEach(function(b){
        b.addEventListener('click', function(){
          var line = parseInt(b.dataset.line,10);
          var item = cart.items[line-1];
          var q = item.quantity + parseInt(b.dataset.d,10);
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:Math.max(0,q)})})
            .then(function(r){ return r.json(); }).then(render);
        });
      });
    }
    var co = document.getElementById('jc-checkout');
    if(co) co.textContent = cart.items.length ? 'Checkout — ' + money(sub) : 'Checkout';
    upsell(cart);
  }
  function refresh(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ render(c); return c; }); }
  refresh();

  /* gift note -> cart attribute */
  var gcb = document.getElementById('jc-gift-cb');
  if(gcb){
    gcb.addEventListener('change', function(){ document.getElementById('jc-gift-txt').style.display = this.checked ? 'block' : 'none'; });
    document.getElementById('jc-gift-txt').addEventListener('change', function(){
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Gift note': this.value}})});
    });
  }

  /* quick add buttons */
  document.querySelectorAll('[data-add-variant]').forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.disabled = true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id: parseInt(btn.dataset.addVariant,10), quantity:1})})
        .then(function(r){ return r.json(); })
        .then(function(added){ rememberAddedPlant(added); btn.disabled = false; openDrawer(); });
    });
  });

  /* PDP add-to-cart via AJAX */
  var pdpForm = document.getElementById('pdp-form');
  if(pdpForm){
    pdpForm.addEventListener('submit', function(e){
      if(e.submitter && e.submitter.classList.contains('atc')){
        e.preventDefault();
        var fd = new FormData(pdpForm);
        fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){ return r.json(); }).then(function(added){ rememberAddedPlant(added); openDrawer(); });
      }
    });
  }
})();

/* Complete Setup included-image lightbox — mobile + desktop */
(function(){
  if(window.JHSetupImageZoom) return;
  window.JHSetupImageZoom = true;

  var style = document.createElement('style');
  style.textContent =
    '.jh-values img{cursor:zoom-in;}' +
    '.jh-zoom-overlay{position:fixed;inset:0;z-index:10000;background:rgba(10,18,8,.88);display:flex;align-items:center;justify-content:center;padding:22px;opacity:0;visibility:hidden;transition:opacity .18s ease,visibility .18s ease;}' +
    '.jh-zoom-overlay.is-open{opacity:1;visibility:visible;}' +
    '.jh-zoom-overlay img{display:block;max-width:min(92vw,1100px);max-height:88vh;width:auto;height:auto;object-fit:contain;border-radius:14px;background:#fff;box-shadow:0 20px 70px rgba(0,0,0,.35);}' +
    '.jh-zoom-close{position:absolute;top:max(16px,env(safe-area-inset-top));right:16px;width:46px;height:46px;border:0;border-radius:50%;background:#fff;color:#173404;font-size:30px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 6px 22px rgba(0,0,0,.2);}' +
    '@media(max-width:749px){.jh-zoom-overlay{padding:14px}.jh-zoom-overlay img{max-width:96vw;max-height:82vh;border-radius:12px}.jh-zoom-close{right:12px;width:44px;height:44px;font-size:28px}}';
  document.head.appendChild(style);

  var overlay = document.createElement('div');
  overlay.className = 'jh-zoom-overlay';
  overlay.setAttribute('role','dialog');
  overlay.setAttribute('aria-modal','true');
  overlay.setAttribute('aria-label','Enlarged product image');
  overlay.innerHTML = '<button type="button" class="jh-zoom-close" aria-label="Close enlarged image">×</button><img alt="">';
  document.body.appendChild(overlay);

  var zoomImg = overlay.querySelector('img');
  var closeBtn = overlay.querySelector('.jh-zoom-close');
  var lastTrigger = null;

  function bestSource(img){
    var set = img.getAttribute('srcset');
    if(set){
      var choices = set.split(',').map(function(part){
        var bits = part.trim().split(/\s+/);
        var width = parseInt(bits[1],10) || 0;
        return {url:bits[0],width:width};
      }).sort(function(a,b){return b.width-a.width;});
      if(choices[0] && choices[0].url) return choices[0].url;
    }
    return img.currentSrc || img.src;
  }

  function openZoom(img){
    lastTrigger = img;
    zoomImg.src = bestSource(img);
    zoomImg.alt = img.alt || 'Included item';
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    closeBtn.focus({preventScroll:true});
  }

  function closeZoom(){
    if(!overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function(){ zoomImg.removeAttribute('src'); },180);
    if(lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus({preventScroll:true});
  }

  document.addEventListener('click',function(e){
    var img = e.target.closest && e.target.closest('.jh-values img');
    if(img){
      e.preventDefault();
      openZoom(img);
      return;
    }
    if(e.target === overlay) closeZoom();
  });

  closeBtn.addEventListener('click',closeZoom);
  document.addEventListener('keydown',function(e){
    if(e.key === 'Escape') closeZoom();
  });
})();

(function(){
  var title = 'Your New Favorite Plant Is Here';
  function fitSignupHeading(){
    var host = document.querySelector('shopify-forms-embed');
    var root = host && host.shadowRoot;
    if(!root) return false;
    var headings = root.querySelectorAll('h2');
    var heading;
    for(var i = 0; i < headings.length; i++){
      if(headings[i].textContent.trim() === title){ heading = headings[i]; break; }
    }
    if(!heading) return false;
    if(!window.matchMedia('(max-width: 600px)').matches){
      heading.style.removeProperty('white-space');
      heading.style.removeProperty('font-size');
      return true;
    }
    heading.style.setProperty('white-space', 'nowrap', 'important');
    for(var size = 22; size >= 12; size -= 0.25){
      heading.style.setProperty('font-size', size + 'px', 'important');
      if(heading.scrollWidth <= heading.clientWidth) break;
    }
    return true;
  }
  var attempts = 0;
  var timer = setInterval(function(){
    attempts++;
    if(fitSignupHeading() || attempts >= 60) clearInterval(timer);
  }, 1000);
  window.addEventListener('resize', fitSignupHeading);
})();
